import i18n from 'app/i18n/i18n'

export const SubscriptionType = Object.freeze({
  VIDEO: 'VIDEO',
  SPORT_VOKRUG_PLUS: 'SPORT_VOKRUG_PLUS'
});

export const SPORT_VOKRUG_PLUS_PROMO_QUERY_PARAM = 'sport_vokrug_plus';
export const SPORT_VOKRUG_PLUS_SUBSCRIPTION_ANCHOR = 'sport-vokrug-plus-subscription';

export const VideoSubscriptionPeriod = Object.freeze({
  MONTH: 'MONTH',
  YEAR: 'YEAR'
});

export  const SportVokrugPlusSubscriptionPeriod = Object.freeze({
  MONTH: 'MONTH',
  FIVE_MONTHS: 'FIVE_MONTHS',
  TEN_MONTHS: 'TEN_MONTHS'
});

export  const SportVokrugPlusSubscription = {
  get [SportVokrugPlusSubscriptionPeriod.MONTH]() {
    return {
      cost: 999,
      title: i18n.t('Monthly'),
      periodTitle: i18n.t('per month'),
    }
  },
  get [SportVokrugPlusSubscriptionPeriod.FIVE_MONTHS]() {
    return {
      cost: 3990,
      title: i18n.t('Half season (5 mo.)'),
      periodTitle: i18n.t('(5 mo.)'),
    }
  },
  get [SportVokrugPlusSubscriptionPeriod.TEN_MONTHS]() {
    return {
      cost: 5990,
      title: i18n.t('Full season (10 mo.)'),
      periodTitle: i18n.t('(10 mo.)'),
    }
  },
};

export const PERIOD_ORDER = [
  SportVokrugPlusSubscriptionPeriod.MONTH,
  SportVokrugPlusSubscriptionPeriod.FIVE_MONTHS,
  SportVokrugPlusSubscriptionPeriod.TEN_MONTHS,
];
